export default {
	"portalPolicyPricePreview.perYear": "pro Jahr",
	"portalPolicyPricePreview.perMonth": "pro Monat",
} as const;
